  <div class="quarter-container">
    <div class="date-header">{{headerName}}</div>
    <div class="quarter-calendar">
      <div class="quarter-panel">
        <!-- <label>Select Quarter Range</label> -->
        <div class="year-nav">
          <button mat-icon-button class="nav-button prev" (click)="moveStartYearPrevious()"  [disabled]="startYear <= minYear"aria-label="Previous year"></button>
          <span>{{ startYear }} - {{ startYear + 2 }}</span>
          <button mat-icon-button class="nav-button next" (click)="moveStartYearNext()" aria-label="Next year" [disabled]="startYear >= maxYear" ></button>
        </div>
        
        <div class="quarter-grid">
          <button
            *ngFor="let quarter of quarters"
            class="quarter-button"
            [class.selected]="isSelected(quarter)"
            [class.disabled]="isDisabled(quarter)"
            (click)="selectQuarter(quarter)"
          >
            {{ quarter }}
          </button>
        </div>
      </div>
    </div>
  
    <!-- Date Input -->
      <div class="date-inputs">
        <div class="input-group">
          <span class="input-group-text" style="padding: 6px 9px;">Start Date</span>
          <input type="text" class="form-control"  [value]="selectedStartQuarter ? (getQuarterStartDate(selectedStartQuarter) | date: 'MM.dd.yyyy') : ''" readonly />
        </div>
        <div class="input-group">
          <span class="input-group-text">End Date</span>
          <input type="text" class="form-control"  [value]="selectedEndQuarter ? (getQuarterEndDate(selectedEndQuarter) | date: 'MM.dd.yyyy') : ''"readonly />
        </div>
      </div>

    <!-- Actions -->
    <div class="actions">
      <button matTooltip="Clear Selection" class="btn clear" (click)="clearSelection()">Clear</button>
      <button matTooltip="Apply Selection"class="btn apply" cdkMenu [disabled]="!selectedStartQuarter || !selectedEndQuarter" (click)="applySelection()">Apply</button>
    </div>

  </div>
  